import data from './consentCategories.json';

/**
 * Single source of truth for consent categories, both for the
 * banner/preference-center UI and for the Cookie Policy page — rendering
 * the policy from this same list means the two can never drift apart the
 * way a dashboard-hosted CMP and a hand-written policy page could.
 *
 * The list itself lives in consentCategories.json so scripts/prerender.mjs can
 * also write it into the served HTML of /privacy/cookie-policy for readers that
 * do not run JavaScript.
 */
export const CONSENT_CATEGORIES = data.categories;
